import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUserStartPageParams {
  userId?: string;
  startPage: string;
}

export class UpdateUserStartPageRequest extends Request<IUpdateUserStartPageParams, IResult> {
  constructor(params: IUpdateUserStartPageParams) {
    super('updateUserStartPage', params);
  }
}
